export default __webpack_public_path__ + "static/media/Loto Quebec - Logo.27b8f025.png";